import { Button, Modal } from '@morressier/alembic';
import { Flex, Text } from '@chakra-ui/react';

interface Props {
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmTemplateModal = ({ onClose, onConfirm }: Props) => {
  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      width="420px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        padding={8}
        gap={4}
      >
        <Text textStyle="headingItem">Switch Template?</Text>
        <Text textStyle="textContext" textAlign="center">
          Are you certain you want to change to a different template? Please
          note that switching will result in losing any changes made to your
          previously selected template.
        </Text>
        <Flex flexDirection="column" gap={2} width="100%">
          <Button variant="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="secondary" onClick={onConfirm}>
            Switch Template
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default ConfirmTemplateModal;
